function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.782.166h4.417c6.066 0 9.611.891 12.758 2.578 3.147 1.687 5.63 4.152 7.298 7.299 1.688 3.147 2.579 6.692 2.579 12.758v4.398c0 6.066-.891 9.611-2.579 12.758s-4.151 5.63-7.298 7.299c-3.147 1.687-6.692 2.578-12.758 2.578h-4.398c-6.066 0-9.611-.891-12.758-2.578-3.147-1.688-5.63-4.152-7.299-7.3C1.057 36.81.166 33.266.166 27.2V22.8c0-6.066.891-9.611 2.578-12.758 1.688-3.147 4.152-5.63 7.299-7.299C13.17 1.057 16.735.166 22.782.166z",
  clipRule: "evenodd",
  fill: "#0068FF",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.834 26.474v.726c0 6.066-.89 9.611-2.578 12.758s-4.152 5.63-7.299 7.298c-3.147 1.688-6.692 2.579-12.758 2.579h-4.398c-4.963 0-8.24-.597-10.99-1.738l-4.535-4.67 42.558-16.953z",
  clipRule: "evenodd",
  fill: "#001A33",
  fillRule: "evenodd",
  opacity: 0.12
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.779 43.589c2.323.257 5.227-.406 7.29-1.407 8.954 4.95 22.951 4.713 31.423-.709a18.69 18.69 0 00.92-1.537C49.107 36.778 50 33.22 50 27.131v-4.414c0-6.089-.894-9.646-2.587-12.805-1.675-3.158-4.167-5.632-7.325-7.325C36.929.893 33.37-.001 27.283-.001h-4.434c-5.185 0-8.551.653-11.38 1.9-.154.138-.306.278-.454.422-8.298 7.999-8.929 25.338-1.893 34.757a.631.631 0 00.026.042c1.085 1.598.039 4.395-1.598 6.03-.266.248-.17.4.229.439z",
  clipRule: "evenodd",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.563 17h-9.725v2.085h6.749l-6.654 8.247c-.209.303-.36.587-.36 1.232v.53h9.175c.455 0 .834-.378.834-.833v-1.119h-7.09l6.256-7.848c.095-.114.265-.322.341-.417l.038-.057c.36-.53.436-.986.436-1.536V17zM32.942 29.095h1.384V17H32.24v11.393a.7.7 0 00.701.701zM25.814 19.692a4.74 4.74 0 104.74 4.74c.018-2.617-2.105-4.74-4.74-4.74zm0 7.526c-1.536 0-2.787-1.251-2.787-2.787s1.251-2.786 2.787-2.786 2.787 1.25 2.787 2.786-1.232 2.787-2.787 2.787zM40.487 19.616a4.781 4.781 0 00-4.777 4.777 4.781 4.781 0 004.777 4.777 4.782 4.782 0 004.777-4.777 4.782 4.782 0 00-4.777-4.777zm0 7.602c-1.554 0-2.806-1.251-2.806-2.806s1.252-2.806 2.806-2.806 2.806 1.252 2.806 2.806-1.251 2.806-2.806 2.806z",
  fill: "#0068FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.456 29.094h1.119v-9.137h-1.953v8.322c0 .436.379.815.834.815z",
  fill: "#0068FF"
});

function SvgZalo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgZalo;